import React from 'react'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'

import * as bodyParts from 'assets/body-parts'
import bodyPartsList from 'assets/metadata/body_parts.json'

import styles from './BodyPart.module.sass'
const bodyPartsMap = {}
bodyPartsList.forEach(({ id, codeAPS }) => {
	bodyPartsMap[codeAPS] = id
})

const BodyPart = (props) => {
	const { className, code, tint, width, height, inline, ...attributes } =
		props
	const imageCode = bodyPartsMap[code] || bodyPartsList[0]?.id
	const imageSrc = bodyParts[imageCode]

	return (
		<div
			{...attributes}
			className={`${styles['root'] || ''} ${className || ''} ${
				styles[tint] || ''
			}`}
			style={{
				width,
				height,
			}}
		>
			{!inline && imageSrc && (
				<div
					className={styles['icon']}
					style={{ backgroundImage: `url(${imageSrc})` }}
				/>
			)}
			{inline && (
				<Icon
					className={styles['icon']}
					width={width}
					height={height}
					name={bodyPartsMap[code] || bodyPartsList[0]?.id}
				/>
			)}
		</div>
	)
}

export default BodyPart
